import { Component } from '@angular/core';
import { FeedbackPlatformPresentationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Presentations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformpresentation-form',
    templateUrl: './feedbackplatformpresentation.form.component.html'
})
export class FeedbackPlatformPresentationFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformPresentationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'committeeSelectionItems', sectionName: 'Committee Selection Items', isExpanded: false },
            { sectionKey: 'reviewAssignments', sectionName: 'Review Assignments', isExpanded: false },
            { sectionKey: 'nominations', sectionName: 'Nominations', isExpanded: false }
        ]);
    }
}

